import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllNomeDeUsuariosPorLoja } from "./services";

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

type GetAllNomeDeUsuariosPorLojaParams = {
  idCliente: number;
  idLoja?: number | null | undefined;
};

export const actionGetAllNomeDeUsuariosPorLoja = createAsyncThunk(
  "ACTION_GET_ALL_NOME_DE_USUARIOS_POR_LOJA",
  async ({ idCliente, idLoja }: GetAllNomeDeUsuariosPorLojaParams) => {
    console.log(
      "Chamando service getAllNomeDeUsuariosPorLoja com idCliente:",
      idCliente,
      "e idLoja:",
      idLoja,
    );
    return getAllNomeDeUsuariosPorLoja(idCliente, idLoja as any);
  },
);

const sliceGetAllNomeDeUsuariosPorLoja = createSlice({
  name: "GET_ALL_NOME_DE_USUARIOS_POR_LOJA",
  initialState,
  reducers: {
    actionResetGetAllNomeDeUsuariosPorLoja: (state) => {
      state.status = "";
      state.data = [];
    },
  },
  extraReducers: {
    [`${actionGetAllNomeDeUsuariosPorLoja.pending}`]: (state) => {
      state.status = "loading";
    },
    [`${actionGetAllNomeDeUsuariosPorLoja.fulfilled}`]: (
      state,
      { payload },
    ) => {
      state.status = "success";
      state.data = payload;
    },
    [`${actionGetAllNomeDeUsuariosPorLoja.rejected}`]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetAllNomeDeUsuariosPorLoja.reducer;
export const { actionResetGetAllNomeDeUsuariosPorLoja } =
  sliceGetAllNomeDeUsuariosPorLoja.actions;
